"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacetFilterService = exports.FilteredFacet = void 0;
const pickBy_1 = __importDefault(require("lodash/pickBy"));
const Logger_1 = __importDefault(require("./Logger"));
const Common_1 = require("./Common");
const FacetFilterOutput_1 = require("./FacetFilterOutput");
const Events_1 = require("./Events");
var FilteredFacet;
(function (FilteredFacet) {
    FilteredFacet["component"] = "component";
    FilteredFacet["content"] = "content";
    FilteredFacet["http"] = "http";
    FilteredFacet["operation"] = "operation";
})(FilteredFacet = exports.FilteredFacet || (exports.FilteredFacet = {}));
class FacetFilterService {
    get headers() {
        const { product } = this.contextService.context.facets;
        return (0, pickBy_1.default)({
            "adsk-adppa-product_build_id": product.build_id,
            "adsk-adppa-product_name": product.name,
            "adsk-adppa-sdk_version": Common_1.SDK_VERSION,
            "adsk-adppa-device_id": this.contextService.context.device_id,
        }, (value) => value);
    }
    get whitelistKey() {
        const { product } = this.contextService.context.facets;
        return `${product.line_name}/${product.release_id}/${product.build_id}`;
    }
    get whitelistUrl() {
        return `${Common_1.SERVERS[this.contextService.context.config.env].whitelist}/${this.whitelistKey}`;
    }
    constructor(contextService, restService) {
        this.contextService = contextService;
        this.restService = restService;
    }
    setup() {
        return __awaiter(this, void 0, void 0, function* () {
            Logger_1.default.debug("BEGIN Initialize Facet Filtering Manager");
            if (this.validateProduct()) {
                yield this.fetch();
            }
            else {
                Logger_1.default.warn("Invalid product for Facet Filtering", this.contextService.context.facets.product);
            }
            Logger_1.default.debug("END Initialize Facet Filtering Manager");
        });
    }
    fetch() {
        return __awaiter(this, void 0, void 0, function* () {
            Logger_1.default.debug("Fetch Facet Filtering Data");
            try {
                const response = yield this.restService.doGetWhitelist(this.whitelistUrl, this.headers);
                Logger_1.default.debug("RESULT", this.whitelistUrl, response.data);
                if (response.data != null && !this.load(response.data)) {
                    Logger_1.default.error("DATA ERROR, wrong data format from server, we cannot do anything more!");
                }
            }
            catch (e) {
                Logger_1.default.error("Error when fetch whitelist", e);
            }
        });
    }
    validateProduct() {
        const { product } = this.contextService.context.facets;
        return !!product.line_name && !!product.release_id && !!product.build_id;
    }
    load(whitelistData) {
        Logger_1.default.debug("Loaded whitelistData", whitelistData);
        if (Array.isArray(whitelistData)) {
            this.facetFilterData = whitelistData
                .filter((whitelist) => whitelist.version != null)
                .filter((whitelist) => whitelist.expiration < 0 || whitelist.expiration >= Date.now())
                .filter((whitelist) => whitelist.experiment_dashboard_id)
                .filter((whitelist) => whitelist.experiment_collection_id);
        }
        return !!this.facetFilterData && !!this.facetFilterData.length;
    }
    doWhitelistFiltering(eventType, facets) {
        if (!(Events_1.EVENTS[eventType].facet in FilteredFacet)) {
            Logger_1.default.debug("SKIP whitelist filtering for", eventType);
            return facets;
        }
        if (this.facetFilterData == null) {
            Logger_1.default.debug("SKIP whitelist filtering because of no whitelist data");
            return facets;
        }
        const result = (0, FacetFilterOutput_1.doWhitelistFiltering)(facets, this.facetFilterData);
        Logger_1.default.debug("FILTERING Result", eventType, facets, this.facetFilterData, result);
        return result;
    }
}
exports.FacetFilterService = FacetFilterService;
